// extracted by mini-css-extract-plugin
export var container = "goldcast-video-embed-module--container--b730d";
export var loadingContainer = "goldcast-video-embed-module--loadingContainer--5f9de";
export var videoPlayer = "goldcast-video-embed-module--videoPlayer--ab052";